var modules_f8db2d70 = {"label":"_t9zjz3"};
import "../../../assets/DkhrF1Gw.css";

export { modules_f8db2d70 as default };
//# sourceMappingURL=Content.module.less.js.map
